import { Environment } from './feature-toggles'

const HOSTS = {
  production: Environment.Production,
  stage: Environment.Stage,
} as const

type TargetEnvironment = keyof typeof HOSTS

/**
 * Returns the equivalent URL on the target environment (production or stage).
 * Preserves the current pathname and search params.
 */
export function getEquivalentUrl(targetEnv: TargetEnvironment): string {
  const { pathname, search, hash } = window.location
  const targetHost = HOSTS[targetEnv]
  return `https://${targetHost}${pathname}${search}${hash}`
}
